import * as React from 'react';
import { DeprecatedEventWrapper } from '../../../../common/analyticsEvents/DeprecatedEventWrapper';
import { IReactTranslateService } from '../../../../common/react/IReactTranslateService';
import { imgPath } from '../../../../common/utilities/ImgUrl';
import { ServerService } from '../../../../ts/services/ServerService';
import { WindowLocationService } from '../../../../ts/services/WindowLocationService';
import { GuidePanel } from '../../components/GuidePanel';

export class GettingStartedPanel extends React.Component<GettingStartedPanel.Props, GettingStartedPanel.State> {

  private windowLocationService: WindowLocationService;

  constructor(props: GettingStartedPanel.Props) {
    super(props);
    this.windowLocationService = props.WindowLocationService;
  }

  private static imageUrl = imgPath('getting_started_online.png');

  private getLocalizedSiteIntroLink() {
    const language = this.props.ServerService.sessionLanguage();
    switch (language) {
      case 'zh':
        return '//www.tableau.com/zh-cn/resource/say-hello-tableau-online';
      case 'fr':
        return '//www.tableau.com/fr-fr/resource/say-hello-tableau-online';
      case 'de':
        return '//www.tableau.com/de-de/resource/say-hello-tableau-online';
      case 'it':
        return '//www.tableau.com/it-it/resource/say-hello-tableau-online';
      case 'ja':
        return '//www.tableau.com/ja-jp/resource/say-hello-tableau-online';
      case 'ko':
        return '//www.tableau.com/ko-kr/resource/say-hello-tableau-online';
      case 'pt':
        return '//www.tableau.com/pt-br/resource/say-hello-tableau-online';
      case 'es':
        return '//www.tableau.com/es-es/resource/say-hello-tableau-online';

      case 'en_GB':
      case 'es_ES':
      case 'fr_FR':
      case 'de_DE':
      case 'ja_JP':
      case 'ko_KR':
      case 'pt_BR':
      case 'zh_CN':
      case 'zh_TW':
          return '//www.tableau.com/'
            + language.toLowerCase().replace('_', '-')
            + '/resource/say-hello-tableau-online';

      case 'en':
      case 'en_US':
      default:
        return '//www.tableau.com/resource/say-hello-tableau-online';
    }
  }

  private openGettingStartedLink = (url: string, title: string, content: string): void => {
    this.windowLocationService.open(url);
    // Deprecated, use TelemetryService instead of AnalyticsEvents.
    this.props.analyticsEvents.sendGettingStartedEvent('site_intro_cta', title, content);
  }

  public render() {
    const content = this.props.translate('gettingStarted_siteIntroContent');
    const ctaText = this.props.translate('gettingStarted_siteIntroCTA_2');
    const ctaUrl = this.getLocalizedSiteIntroLink();
    const callback = () => this.openGettingStartedLink(ctaUrl, ctaText, content);

    return (
      <GuidePanel
        imgUrl={ GettingStartedPanel.imageUrl }
        content={ content }
        callToActionText={ ctaText }
        callback={ callback }
      />
    );
  }
}

export module GettingStartedPanel {
  export interface Props {
    ServerService: ServerService;
    translate: IReactTranslateService;
    analyticsEvents: DeprecatedEventWrapper;
    WindowLocationService: WindowLocationService;
  }

  export interface State {}
}
